import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Car, Plus, Heart, LayoutDashboard, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUser } from "@/context/UserContext";
import { SellerBadge } from "@/components/SellerBadge";

const navCls = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 hover:text-slate-900 ${isActive ? "text-slate-900" : "text-slate-500"}`;

export const Header = () => {
  const { me } = useUser();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/90 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 rounded-xl bg-slate-900 text-white grid place-items-center"><Car size={18} /></span>
          <span className="font-heading text-xl font-extrabold tracking-tight">Buy<span className="text-blue-600">Now</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          <NavLink to="/cerca" className={navCls} data-testid="nav-search-link">Cerca veicoli</NavLink>
        </nav>
        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <Show when="signed-in">
            {me?.account_type && <span className="hidden lg:inline-flex"><SellerBadge type={me.account_type} /></span>}
            {me?.role === "admin" && (
              <Link to="/admin" data-testid="nav-admin-link" className="hidden sm:inline-flex p-2 rounded-lg text-slate-600 hover:bg-slate-100" title="Pannello Amministrazione"><Shield size={18} /></Link>
            )}
            <Link to="/area-personale?tab=preferiti" data-testid="nav-favorites-link" className="p-2 rounded-lg text-slate-600 hover:bg-slate-100" title="Preferiti"><Heart size={18} /></Link>
            <Link to="/area-personale" data-testid="nav-dashboard-link" className="p-2 rounded-lg text-slate-600 hover:bg-slate-100" title="Area personale"><LayoutDashboard size={18} /></Link>
            {me?.role === "admin" && (
              <Button asChild data-testid="nav-create-listing-button" className="rounded-full bg-blue-600 hover:bg-blue-700">
                <Link to="/vendi"><Plus size={16} className="mr-1" /><span className="hidden sm:inline">Pubblica</span></Link>
              </Button>
            )}
            <UserButton />
          </Show>
          <Show when="signed-out">
            <Button asChild variant="ghost" data-testid="nav-login-button" className="rounded-full"><Link to="/accedi">Accedi</Link></Button>
            <Button asChild data-testid="nav-register-button" className="rounded-full bg-slate-900 hover:bg-slate-800"><Link to="/registrati">Registrati</Link></Button>
          </Show>
        </div>
      </div>
      <nav className="md:hidden flex gap-5 px-4 h-10 items-center border-t border-slate-100 overflow-x-auto">
        <NavLink to="/cerca" className={navCls} data-testid="nav-mobile-search-link">Cerca veicoli</NavLink>
      </nav>
    </header>
  );
};
